import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export function animationCrosstalk() {
  // インタビューアイテムと画像の要素を取得
  const interviewItems = document.querySelectorAll('.js-interview-item');
  const interviewImages = document.querySelectorAll('.js-interview-image');
  const imageWrap = document.querySelector('.p-interview__image-wrap');
  const container = document.querySelector('.p-interview__container');
  const crosstalkSection = document.querySelector('.p-crosstalk');
  const header = document.querySelector('.l-header');
  
  // 要素が存在しない場合は処理を終了
  if (!interviewItems.length || !interviewImages.length || !imageWrap || !container) return;

  let currentActiveIndex = 0;

  // 画像切り替えファンクション
  const switchImage = (newIndex) => {
    if (newIndex === currentActiveIndex) return;

    const currentImage = interviewImages[currentActiveIndex];
    const newImage = interviewImages[newIndex];

    if (currentImage && newImage) {
      // 現在の画像をフェードアウト
      gsap.to(currentImage, {
        opacity: 0,
        duration: 0.3,
        ease: "power2.out",
        onComplete: () => {
          currentImage.classList.remove('is-active');
        }
      });

      // 新しい画像をフェードイン
      gsap.set(newImage, { opacity: 0 });
      newImage.classList.add('is-active');
      gsap.to(newImage, {
        opacity: 1,
        duration: 0.3,
        delay: 0.1,
        ease: "power2.out"
      });

      currentActiveIndex = newIndex;
    }
  };

  // 画像をpinで固定（デスクトップのみ）
  const mm = gsap.matchMedia();
  
  mm.add("(min-width: 769px)", () => {
    // ヘッダーの高さを動的に取得
    const headerHeight = header ? header.offsetHeight : 0;
    
    ScrollTrigger.create({
      trigger: container,
      start: `top ${headerHeight - 1}px`,
      end: "bottom bottom",
      pin: imageWrap,
      pinSpacing: false,
    });
  });

  // p-interview__wrapを3分割して画像切り替えを制御
  const interviewWrap = document.querySelector('.p-interview__wrap');
  if (interviewWrap && interviewImages.length >= 3) {
    ScrollTrigger.create({
      trigger: interviewWrap,
      start: 'top center',
      end: 'bottom center',
      onUpdate: (self) => {
        const progress = self.progress;
        let newIndex = 0;
        
        if (progress >= 0 && progress < 1/3) {
          newIndex = 0; // 1枚目
        } else if (progress >= 1/3 && progress < 2/3) {
          newIndex = 1; // 2枚目
        } else if (progress >= 2/3) {
          newIndex = 2; // 3枚目
        }
        
        switchImage(newIndex);
      }
    });
  }

  // ページロード時の初期設定
  interviewImages.forEach((img, index) => {
    if (index === 0) {
      gsap.set(img, { opacity: 1 });
      img.classList.add('is-active');
    } else {
      gsap.set(img, { opacity: 0 });
      img.classList.remove('is-active');
    }
  });

  // ヘッダーの色変更処理
  if (crosstalkSection && header) {
    const logoImg = document.querySelector('.l-header__logo img');
    const headerHeight = header.offsetHeight;
    
    ScrollTrigger.create({
      trigger: crosstalkSection,
      start: `bottom top+=${headerHeight}px`,
      end: `bottom top+=${headerHeight}px`,
      onEnter: () => {
        // p-crosstalkセクションを過ぎたら白背景モードに
        header.classList.add('is-white-bg');
        // ロゴを黒色版に変更
        if (logoImg) {
          logoImg.src = logoImg.src.replace('logo_white.svg', 'logo.svg');
        }
      },
      onLeaveBack: () => {
        // p-crosstalkセクションに戻ったら白背景モードを解除
        header.classList.remove('is-white-bg');
        // ロゴを白色版に変更
        if (logoImg) {
          logoImg.src = logoImg.src.replace('logo.svg', 'logo_white.svg');
        }
      }
    });
  }
}